import React from "react";
import { getAwsAssets } from "@src/utils/index";
import contentHasThumbnail from "../../helpers/contentHasThumbnail";
import getContentThumbnail from "../../helpers/getContentThumbnail";
import isContentVideo from "../../helpers/isContentVideo";
import styles from "../../styles/ContentList.module.scss";
import { Image } from "@src/components/Image";
import VideoProgressBar from "./VideoProgressBar";
import isVideoExhausted from "../../helpers/isVideoExhausted";
import { CONTENT_TYPE } from "../../store/constants";

const ListItemThumbnail = ({ content }) => {
  return (
    <div
      className={`${styles.contentList__item__thumbnail} ${
        isVideoExhausted(content) &&
        styles["contentList__item__thumbnail--exhausted"]
      }`}
      style={
        contentHasThumbnail(content) ||
        content?.contentType === CONTENT_TYPE.VIDEO
          ? { background: `url(${getContentThumbnail(content)})` }
          : {}
      }
    >
      {/* <p>{`hello${contentHasThumbnail(content)}`}</p> */}
      {content?.imageUrl ? (
        <img src={content?.imageUrl} alt="thumbnail" width={80} height={60}/>
      ) : (
        !(contentHasThumbnail(content) || content?.contentType === CONTENT_TYPE.VIDEO) && (
          content?.testFormat === 2 ?  <Image
          src={"https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/quiz-icon-file.jpg"}
          alt="thumbnail"
          width={74}
          height={66}
        /> : <Image
            src={getContentThumbnail(content)}
            alt="thumbnail"
            width={38}
            height={38}
          />
        )
      )}

      {isContentVideo(content?.contentType) && (
        <Image
          src={getAwsAssets("playIcon.svg", "content")}
          alt="playIcon"
          width={20}
          height={20}
        />
      )}
      {isContentVideo(content?.contentType) &&
        content?.duration &&
        content.duration !== "undefined" && (
          <div className={styles.contentList__item__thumbnail__durationBar}>
            {content?.duration}
          </div>
        )}
      {isContentVideo(content?.contentType) && (
        <VideoProgressBar
          lastSeek={content?.lastSeek}
          duration={content?.duration}
          videoMaxDuration={content?.videoMaxDuration}
        />
      )}
    </div>
  );
};

export default ListItemThumbnail;
